const translations = {
    workOrder: 'Work Order Name'
};

export default translations;
